import { canMeasure } from '@/lib/privacy';
import { createClient } from '@base44/sdk';
import { appParams } from '@/lib/app-params';

const { appId, token, functionsVersion, appBaseUrl } = appParams;

//Create a client with authentication required
export const base44 = createClient({
  appId,
  token,
  functionsVersion,
  serverUrl: '',
  requiresAuth: false,
  analytics: { enabled: false },
  appBaseUrl
});

// Explicit generic counts use the first-party entity endpoint; SDK automatic
// session/URL collection is disabled above.
base44.analytics.track = async ({ eventName, properties = {} } = {}) => {
  const consentedBooking = eventName === 'consultation_booking_start' && window.tdaHasOpenAIConsent?.();
  if (!canMeasure() && !consentedBooking) return;
  const allowed = new Set(['cta_click', 'consultation_booking_start']);
  if (!allowed.has(eventName)) return;
  const safe = {};
  if (['call', 'contact', 'book-appointment'].includes(properties.cta_type)) safe.cta_type = properties.cta_type;
  const campaign = {};
  if (eventName === 'consultation_booking_start') {
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
      const value = properties[key];
      if (typeof value === 'string' && /^[a-z0-9_.-]{1,200}$/i.test(value)) campaign[key] = value;
    }
  }
  const event = { type: 'abtest', payload: {
    test_id: eventName, variant_id: safe.cta_type || safe.destination || 'generic', event_type: 'click',
    metadata: campaign,
  } };
  if (eventName === 'consultation_booking_start') {
    // Continue sending when the click navigates away from this page.
    return base44.functions.fetch('/trackEvent', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(event), keepalive: true,
    }).catch(() => null);
  }
  return base44.functions.invoke('trackEvent', event).catch(() => null);
};